module.exports = __webpack_public_path__ + "img/gallery-5.8a55244a.jpg";